"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var NumberValidator_1 = require("../../../utils/NumberValidator");
exports.greaterThanValidator = {
    name: 'greaterThan',
    validation: function (value, element, config) {
        return NumberValidator_1.NumberValidator.validate(value, config, 'limit', function (value, limit) {
            return value > limit;
        });
    },
};
//# sourceMappingURL=GreaterThanValidator.js.map